import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { fetchUserProfiles } from "../api/auth";   
import { Spinner } from "reactstrap"; // Assuming you have reactstrap installed

const ViewProfilesTable = () => {
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchUserProfiles().then((profiles) => {
            setData(profiles.data);
            setLoading(false);
        });
    }, []);

    const columns = [
        { 
            name: "Username", 
            cell: (row) => (
                <Link to={`/profile/${row.username}`} className="text-blue-500 hover:underline">
                    {row.username}
                </Link>
            ), 
            sortable: true, 
            center: "true"
        },
        { name: "Codeforces Handle", selector: (row) => row.cfHandle, sortable: true, center: "true"},
        { name: "Organisation", selector: (row) => row.organisation, sortable: true, center: "true"},
    ];

    const filteredData = data.filter(
        (item) =>
            item.username.toLowerCase().includes(filterText.toLowerCase()) ||
            item.cfHandle.toLowerCase().includes(filterText.toLowerCase()) ||
            item.organisation.toLowerCase().includes(filterText.toLowerCase())
    );

    return (
        <div className="p-4">
            <div className="flex justify-end mb-4">
                <input
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => setFilterText(e.target.value)}
                    className="w-full sm:w-64 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
            </div>
            <div className="rounded-lg border border-gray-200 shadow-md overflow-hidden">
                {loading ? (
                    <div className="flex justify-center items-center p-4">
                        <Spinner color="primary" />
                    </div>
                ) : (
                    <DataTable
                        columns={columns}
                        data={filteredData}
                        pagination
                        customStyles={{
                            table: {
                                style: {
                                    textAlign: "center", // Center the table content
                                    borderWidth: "1px",
                                    borderStyle: "solid",
                                    borderColor: "#e5e7eb", // Tailwind's `gray-300`
                                },
                            },
                            headRow: {
                                style: {
                                    backgroundColor: "#f3f4f6", // Slightly darker than the rows
                                    fontWeight: "bold",
                                    textAlign: "center", // Centers the header text
                                    borderBottom: "2px solid #e5e7eb", // Thicker bottom border for header
                                },
                            },
                            headCells: {
                                style: {
                                    textAlign: "center", // Centers the text in the header cells
                                    padding: "12px", // More space for better readability
                                    borderRight: "1px solid #e5e7eb", // Add right border to header cells
                                },
                            },
                            rows: {
                                style: {
                                    textAlign: "center", // Centers row content
                                    borderBottom: "1px solid #e5e7eb", // Thin border between rows
                                    "&:nth-of-type(even)": {
                                        backgroundColor: "#f9fafb", // Alternate row background
                                    },
                                    "&:nth-of-type(odd)": {
                                        backgroundColor: "#ffffff", // Regular rows background
                                    },
                                },
                            },
                            cells: {
                                style: {
                                    textAlign: "center",
                                    padding: "10px", // Adequate padding inside cells
                                    borderRight: "1px solid #e5e7eb", // Add right border to cells
                                },
                            },
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default ViewProfilesTable;
